import { OnboardingInfo } from '../index';

export enum OnboardingPageType {
    IntroText = 'intro_text',
    Idea = 'idea_text',
    Project = 'project_text',
    Result = 'result_text',
    OutroText = 'outro_text'
}

function filterOnboardingInfos(infos: OnboardingInfo[], type: OnboardingPageType | null) {
    return infos.filter((info) => info.pageType === type);
}

export function setupOnboardingOrder(onboardingInfo: OnboardingInfo[]): OnboardingInfo[] {
    return onboardingInfo.reduce((orderedInfos: OnboardingInfo[], onboardingInfo) => {
        const existingIntros = filterOnboardingInfos(orderedInfos, OnboardingPageType.IntroText);
        const existingIdeas = filterOnboardingInfos(orderedInfos, OnboardingPageType.Idea);
        const existingProjects = filterOnboardingInfos(orderedInfos, OnboardingPageType.Project);
        const existingResults = filterOnboardingInfos(orderedInfos, OnboardingPageType.Result);
        const existingOutros = filterOnboardingInfos(orderedInfos, OnboardingPageType.OutroText);
        const existingNoTypes = filterOnboardingInfos(orderedInfos, null);

        switch (onboardingInfo.pageType) {
            case OnboardingPageType.IntroText:
                return [
                    ...existingIntros,
                    onboardingInfo,
                    ...existingIdeas,
                    ...existingProjects,
                    ...existingResults,
                    ...existingNoTypes,
                    ...existingOutros
                ];
            case OnboardingPageType.Idea:
                return [
                    ...existingIntros,
                    ...existingIdeas,
                    onboardingInfo,
                    ...existingProjects,
                    ...existingResults,
                    ...existingNoTypes,
                    ...existingOutros
                ];
            case OnboardingPageType.Project:
                return [
                    ...existingIntros,
                    ...existingIdeas,
                    ...existingProjects,
                    onboardingInfo,
                    ...existingResults,
                    ...existingNoTypes,
                    ...existingOutros
                ];
            case OnboardingPageType.Result:
                return [
                    ...existingIntros,
                    ...existingIdeas,
                    ...existingProjects,
                    ...existingResults,
                    onboardingInfo,
                    ...existingNoTypes,
                    ...existingOutros
                ];
            case OnboardingPageType.OutroText:
                return [
                    ...existingIntros,
                    ...existingIdeas,
                    ...existingProjects,
                    ...existingResults,
                    ...existingNoTypes,
                    ...existingOutros,
                    onboardingInfo
                ];
            default:
                return [
                    ...existingIntros,
                    ...existingIdeas,
                    ...existingProjects,
                    ...existingResults,
                    ...existingNoTypes,
                    onboardingInfo,
                    ...existingOutros
                ];
        }
    }, []);
}
